import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
    html {
    box-sizing: border-box;
    font-size: 1rem;
    color: #666666;
    -ms-overflow-style: -ms-autohiding-scrollbar;    
    h1,h2,h3,h4,h5,h6,p{
      margin: 0;
      padding: 0;
    }
  }

  

  

  
`;
